import React from 'react';

const WhatClientsSay: React.FC = () => {
  return (
    <section className="WhatClientsSay">
      <div className="WhatClientsSay__inner">
        <h2 className="WhatClientsSay__title">What our clients say</h2>

        <div className="WhatClientsSay__grid">
          <div className="WhatClientsSay__item">
            <p className="WhatClientsSay__quote">
              “Renaissance has cornered the market for smart and timely pre-IPO research.”
            </p>
            <div className="WhatClientsSay__attrib">-SMID Cap Fund Manager</div>
          </div>

          <div className="WhatClientsSay__item">
            <p className="WhatClientsSay__quote">
              “It makes my job easier with timely tracking, intelligent commentary and unbiased analysis.”
            </p>
            <div className="WhatClientsSay__attrib">-100B+ Pension Fund</div>
          </div>

          <div className="WhatClientsSay__item">
            <p className="WhatClientsSay__quote">
              “Their research is essential to helping us allocate resources and ensuring we don’t miss a deal.”
            </p>
            <div className="WhatClientsSay__attrib">-100B+ Pension Fund</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhatClientsSay;
